window.RebuyCustom = window.RebuyCustom || {
  setItemQuantity(item, quantity) {
    if (!window.Rebuy) return;
    return window.Rebuy.Cart.setItemQuantity(item, quantity);
  },
};

document.addEventListener('rebuy:cart.ready', (event) => {
  totalSavingAmount();
  progressBarFreeShipping(); 
});

document.addEventListener('rebuy:cart.change', (event) => {
  const cart = event.detail.cart;
  const cartCountEl = document.querySelector('.siteHeader [data-cart-count]');
  if (cartCountEl && typeof cart?.itemCount === 'function') {
    cartCountEl.innerText = cart.itemCount();
    if (cart.itemCount() > 0) {
      cartCountEl.classList.remove('hidden');
    } else {
      cartCountEl.classList.add('hidden');
    }
  }
  const itemQuantity = [...document.querySelectorAll('cart-items .cart-item [data-quantity-input]')]?.map((item) => {
    const quantity = item.value;
    return quantity ? parseInt(quantity) : 0;
  });
  const matchesCart = cart.items()?.length === itemQuantity?.length && cart.items()?.every((item, index) => item.quantity === itemQuantity?.[index] && itemQuantity?.[index]);
  if (window.location.href?.includes('/cart') && !matchesCart) {
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    cartItems.updateQuantity(1, cart.items()[0]?.quantity);
  }

  const addToCartButtons = document.querySelectorAll('.product-form__submit, .sticky-submit');
  addToCartButtons.forEach((button) => {
    const productName = button.dataset.productName;
    const totalQuantity = cart.items().reduce((sum, item) => {
      return item.product_title === productName ? sum + item.quantity : sum;
    }, 0);
    if (totalQuantity > 0 && window?.theme?.enable_product_limitation == true) {
      button.disabled = totalQuantity >= window?.theme?.max_product_quantity;
    }
  });
    if (window?.theme?.enable_product_limitation === true) {

        const items = event.detail.cart.cart.items;
        const forms = document.querySelectorAll('product-info, nss-add-to-cart');

        forms.forEach(form => {
            const variantInput = form.querySelector('[name="id"]');
            const sellingPlanInput = form.querySelector('[name="selling_plan"]');
            const submitBtn = form.querySelector('[type="submit"]');

            if (!variantInput || !submitBtn) return;

            const variantId = Number(variantInput.value);
            const sellingPlanId = sellingPlanInput ? Number(sellingPlanInput.value) : null;

            const cartItem = items.find(item => {
                const itemSellingPlan = item.selling_plan_allocation
                    ? item.selling_plan_allocation.selling_plan_id
                    : null;

                return (
                    item.variant_id === variantId &&
                    (itemSellingPlan === sellingPlanId)
                );
            });

            if (cartItem) {
                if (cartItem.quantity >= window.theme.max_product_quantity) {
                    submitBtn.disabled = true;
                } else {
                    submitBtn.disabled = false;
                }
            } else {
                const btnText = submitBtn.querySelector('.nss-button__text');
                if (!btnText || !btnText.innerText.toLowerCase().includes('sold')) {
                    submitBtn.disabled = false;
                }
            }
        });
    }
  totalSavingAmount();
  progressBarFreeShipping();
});

document.addEventListener('DOMContentLoaded', () => {
  function waitForElm(selector) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  waitForElm('.rebuy-cart__flyout-title').then(function () {
    let titleCart = document.querySelector('.rebuy-cart__flyout-title');
    titleCart.insertAdjacentHTML('beforeend', '<span></span>');
  });

  document.addEventListener('rebuy:cart.change', async () => {
    const res = await fetch('/cart.js');
    const data = await res.json();

    waitForElm('.rebuy-cart__flyout-title').then(function () {
      let titleCart = document.querySelector('.rebuy-cart__flyout-title');
      titleCart.querySelector('span').innerHTML = `(${data.item_count})`;
    });

    let cartPageTitle = document.querySelector('[data-cart-item-count]');
    if (cartPageTitle) cartPageTitle.innerHTML = `(${data.item_count})`;
  });
});

function calculateSavingAmount() {
  const cart = window.Rebuy.Cart.cart;
  const cartItems = document.querySelectorAll('.rebuy-cart__flyout-item');
  const savingAmount = cart.items.reduce((acc, item, index) => {
    const cartItem = cartItems[index];
    if (cartItem) {
      const compareAtPriceEl = cartItem.querySelector('.compare-at__price');
      if (compareAtPriceEl) {
        const compareAtPrice = parseFloat(compareAtPriceEl.textContent.replace(/[^0-9.-]+/g, ''));

        return acc + item.quantity * (Math.round(compareAtPrice * 100) - item.final_price);
      }
    }
    return acc;
  }, 0);

  document.querySelectorAll('.rebuy-cart__flyout-savings-amount').forEach((savingsAmountElement) => {
    if (savingAmount > 0) {
      savingsAmountElement.closest('.rebuy-cart__flyout-savings').style.removeProperty('display');
      savingsAmountElement.textContent = window.Rebuy.Cart.formatMoney(savingAmount);
    } else {
      savingsAmountElement.closest('.rebuy-cart__flyout-savings').style.display = 'none';
    }
  });
}

function totalSavingAmount() {
  if (!window?.Rebuy?.Cart) return '';

  const cartContainer = document.querySelector('.rebuy-cart__flyout-content');
  if (!cartContainer) return '';

  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        observer.disconnect();
        return this.calculateSavingAmount();
      }
    }
  });

  observer.observe(cartContainer, { childList: true, subtree: true });
}

// Updates the height of the Flickity viewport to match the height of the visible product block - this prevents too much/little space on the blocks
document.addEventListener('rebuy.ready', function(event){
  function updateFlickityViewportHeight() {
    const productBlocks = document.querySelectorAll('.rebuy-cart__flyout-recommendations .rebuy-product-grid .rebuy-product-block');
    let maxHeight = 0;
    
    productBlocks.forEach((block) => {
      if (block.getAttribute('aria-hidden') !== 'true') {
        const innerBlock = block.querySelector('.rebuy-product-block__inner');
        const blockHeight = innerBlock.offsetHeight;
        maxHeight = blockHeight;
      }
    });
  
    const flickityViewport = document.querySelector('.rebuy-cart__flyout-recommendations .rebuy-product-grid .flickity-viewport');
    if (flickityViewport) {
      flickityViewport.style.height = `${maxHeight}px`;
      flickityViewport.style.touchAction = 'pan-y';
    }
  }
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        updateFlickityViewportHeight();
      }
    });
  });
  
  const productBlocks = document.querySelectorAll('.rebuy-cart__flyout-recommendations .rebuy-product-grid .rebuy-product-block');
  
  productBlocks.forEach((block) => {
    observer.observe(block, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
  });
});

function progressBarFreeShipping() {
    const freeShippingTier = Rebuy.SmartCart?.progressBar?.tiers?.find(tier => tier.type === 'shipping');
    const cartItems = document.querySelectorAll('.rebuy-cart__flyout-item');
    let hasFreeShippingItem = false;

    cartItems.forEach(item => {
        if (item.classList.contains('tag-free-shipping') || item.classList.contains('tag-freeshipping')) {
            hasFreeShippingItem = true;
        }
    });
    if (freeShippingTier != null) {
        freeShippingTier.minimum = (cartItems.length === 0 || !hasFreeShippingItem) ? 45 : 0;
    }
}
